function importAll(context) {
  return context.keys().map(context);
}

importAll(require.context('images/', false, /\.(png|gif|jpe?g|svg)$/));
importAll(require.context('images/static_wpf/', false, /\.(png|jpe?g|svg)$/));
importAll(require.context('images/v2/wpf_custom_theme/card_brands/', false, /\.(png|jpe?g|svg)$/));
importAll(require.context('images/v2/wpf_custom_theme/brands/v2/dark', false, /\.(png|jpe?g|svg)$/));
importAll(require.context('images/v2/wpf_custom_theme/brands/v2/light', false, /\.(png|jpe?g|svg)$/));
importAll(require.context('images/v2/wpf_custom_theme/card_brands/v2/', false, /\.(png|jpe?g|svg)$/));
importAll(require.context('images/v2/wpf_custom_theme/transaction_types/v2/', false, /\.(png|jpe?g|svg)$/));